import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { Translation } from '@/hoslog-intl';
import { FileIcon } from '@/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/logs-management/static-data-type/$staticDataTypeName')({
  loader: () => {
    return {
      crumb: <CrumbTitle id="logsManagement.staticDataTypeLabel.crumb.staticDataTypeLabel" icon={FileIcon} />,
      title: <Translation id="logsManagement.staticDataTypeLabel.crumb.staticDataTypeLabel" />,
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div>
      <Outlet />
    </div>
  );
}
